import * as yup from "yup";
import { ReactSelectOption } from "../../models/generic";
import { Tag } from "../../models/tag";
import { FormValidationModel } from "../../models/validation";
import { ReactSelectOptionSchema } from "../generic";
import "../../utils/YupHelper";

export interface AbstractMediaData {
    caption?: string;
    deleted: boolean;
    embedUrl?: string;
    fileName?: string;
    height?: number;
    id: number;
    index: number;
    isImage: boolean;
    isProcessing: boolean;
    isVideo: boolean;
    mediaId: number;
    tags: Array<ReactSelectOption | Tag | null>;
    thumbMd: string | null;
    thumbSm: string | null;
    title: string | null;
    typeId: number;
    url?: string;
    width?: number;
}

export class AbstractMedia implements FormValidationModel<AbstractMediaData> {
    public data: AbstractMediaData;
    public rules: yup.Schema<AbstractMediaData>;

    public constructor() {
        this.data = {
            deleted: false,
            id: 0,
            index: 0,
            isImage: false,
            isProcessing: false,
            isVideo: false,
            mediaId: 0,
            tags: [],
            thumbMd: null,
            thumbSm: null,
            title: null,
            typeId: 0,
        };
        this.rules = yup.object<AbstractMediaData>().shape({
            caption: yup.string().nullable(true).label("Caption").when(["deleted"], (deleted: boolean) => {
                return deleted
                    ? yup.string().nullable(true).label("Caption")
                    : (yup.string().nullable(true).label("Caption").max(1000) as any).wordcount_max(75);
            }),
            deleted: yup.bool(),
            embedUrl: yup.string().nullable(true),
            fileName: yup.string().nullable(true),
            height: yup.number().nullable(true),
            id: yup.number().required().label("ID").min(0, "Invalid ID"),
            index: yup.number(),
            isImage: yup.bool(),
            isProcessing: yup.bool(),
            isVideo: yup.bool(),
            mediaId: yup.number(),
            tags:  yup.array().of(ReactSelectOptionSchema.label("Tags")),
            thumbMd: yup.string().nullable(true),
            thumbSm: yup.string().nullable(true),
            title: yup.string().nullable(true).label("Title").when(["deleted"], (deleted: boolean) => {
                return deleted
                    ? yup.string().nullable(true).label("Title")
                    : (yup.string().nullable(true).label("Title").max(500) as any).wordcount_max(100);
            }),
            typeId: yup.number(),
            url: yup.string().nullable(true),
            width: yup.number().nullable(true),
        });
    }
}

export const DefaultAbstractMedia = { ...new AbstractMedia().data };
export const AbstractMediaSchema = new AbstractMedia().rules;



// WEBPACK FOOTER //
// ./src/forms/abstract/AbstractMedia.ts